import React from 'react'
import Link from '../utils/link'
import Fade from 'react-reveal/Fade'

const Breadcrumbs = ({ wpPage }) => {
  return (
    <section className='breadcrumbs'>
      <Fade bottom distance={'40px'}>
        <div className='breadcrumbs__inner'>
          <nav>
            {wpPage.nodeType === 'Brand' && (
              <Link to={'/brands/'}>{'Brands'}</Link>
            )}
            {wpPage.nodeType === 'Machine' && (
              <Link to={'/products/'}>{'Products'}</Link>
            )}
            {wpPage.ancestors?.nodes?.reverse().map((el, i) => (
              <Link key={i} to={el.uri}>{el.title}</Link>
            ))}
            <Link to={wpPage.uri}>{wpPage.title}</Link>
          </nav>
        </div>
      </Fade>
    </section>
  )
}

export default Breadcrumbs